<template>
	<div>
		<myheader :headTitle="headertitle"></myheader>
		<div class="all_main backgroundC_white">
			<div class="all_content_padding">
				<div class="text14 textcolor333 margin_top_5" style="white-space: pre-wrap;padding: .5rem;">
					{{content}}
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import Vue from "vue";
	import {
		RealNameAuthenticationServiceAgreement,
		PrivacyPolicyStatementAgreement,
		UserServiceAgreement
	} from '../../utils/text.js'
	export default {
		data() {
			return {
				//头部标题
				headertitle: '用户服务协议',
				//
				content: '',
				//
				type: 1, // 3 实人认证服务协议  2 隐私政策与声明协议  1 用户服务协议
				//实人认证服务协议
				RealNameAuthenticationServiceAgreement,
				//隐私政策与声明协议
				PrivacyPolicyStatementAgreement,
				//用户服务协议
				UserServiceAgreement
			};
		},
		mounted() {
			this.type = this.$route.params.type
			switch (this.type) {
				case 1:
					this.headertitle = '用户服务协议'
					this.content = UserServiceAgreement
					break;
				case 2:
					this.headertitle = '隐私政策声明'
					this.content = PrivacyPolicyStatementAgreement
					break;
				case 3:
					this.headertitle = '实名认证服务协议'
					this.content = RealNameAuthenticationServiceAgreement
					break;
			}
		},
		methods: {
			
		}
	};
</script>

<style scoped lang="scss">
	@import "../../styles/global.css";
	
</style>